import React, { forwardRef } from 'react'
import { SxStyleProp, TextProps } from 'rebass'

import FParagraph from '../FParagraph'

interface Props extends TextProps {
    textStyles?: SxStyleProp
    paragraphs: string[]
}

export const FParagraphGroup = forwardRef<any, Props>((props: Props, ref) => {
    return (
        <React.Fragment>
            {props.paragraphs.map((paragraph, index) => (
                <FParagraph text={paragraph} key={index} textStyles={props.textStyles} />
            ))}
        </React.Fragment>
    )
})

FParagraphGroup.displayName = 'FParagraphGroup'

export default FParagraphGroup
